import { render, staticRenderFns } from "./allList.vue?vue&type=template&id=40a6fdb0&scoped=true"
import script from "./allList.vue?vue&type=script&lang=js"
export * from "./allList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a6fdb0",
  null
  
)

export default component.exports